import React from 'react';
import ReactMarkdown from 'react-markdown';
import { GeneratedScript } from 'src/api/generatedContent';
import styles from './VideoScript.module.scss';

interface ContentPreviewProps {
  script: GeneratedScript;
}

const VideoScript: React.FC<ContentPreviewProps> = ({ script }) => {
  return (
    <div className={styles.scriptContainer}>
      <div className={styles.titleSection}>
        <h2>{script.title}</h2>
      </div>

      <div className={styles.contentSection}>
        <ReactMarkdown>{script.content}</ReactMarkdown>
      </div>
    </div>
  );
};

export default VideoScript;
